import React                  from 'react';
import { arrayUp as tooltip } from 'pu-data/Tooltips';
import TextComponent          from './TextComponent';

export default (props) => {
  const name = 'array_up';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="# of up in array"
      inputClassName="array-up"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};
